import { createSlice } from '@reduxjs/toolkit';
import { findRegistrationRejectionReasons } from './api';
import { initialState } from './api/interface';

const registrationRejectionReasonsSlice = createSlice({
  name: 'registrationRejectionReasons',
  initialState,
  reducers: {
    setLimit: (state, action) => {
      state.limit = action.payload.limit;
      state.status = 'idle';
    },
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
      state.status = 'idle';
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload.currentPage;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findRegistrationRejectionReasons.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(
      findRegistrationRejectionReasons.fulfilled,
      (state, action) => {
        state.data = action.payload.data;
        state.totalRecords = action.payload.total;
        state.isError = false;
        state.isSuccess = true;
        state.isLoading = false;
        state.status = 'succeeded';
      }
    );
    builder.addCase(findRegistrationRejectionReasons.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
  },
});

export const { setLimit, setSkip, setCurrentPage, setStatus, reset } =
  registrationRejectionReasonsSlice.actions;
export default registrationRejectionReasonsSlice.reducer;
